import { create } from "zustand";
import {
  getKanban,
  updateConfirmationStatus,
  type KanbanCard,
} from "../services/whatsapp/whatsappService";
import { handleApi } from "../utils/handleApi";

interface KanbanState {
  columns: Record<string, KanbanCard[]>;
  totals: Record<string, number>;
  loading: boolean;
  searchQuery: string;

  fetchKanban: (ownerId: string) => Promise<void>;
  moveCard: (
    cardId: number,
    sourceCol: string,
    targetCol: string,
    targetStatus: string
  ) => Promise<boolean>;
  setSearchQuery: (query: string) => void;
  reset: () => void;
}

export const useKanbanStore = create<KanbanState>((set, get) => ({
  columns: {},
  totals: {},
  loading: true,
  searchQuery: "",

  fetchKanban: async (ownerId) => {
    set({ loading: true });
    const { res, error } = await handleApi(getKanban(ownerId), false);
    if (!error && res) {
      set({ columns: res.columns, totals: res.totals, loading: false });
    } else {
      set({ loading: false });
    }
  },

  moveCard: async (cardId, sourceCol, targetCol, targetStatus) => {
    const prev = { ...get().columns };

    // Find the card
    const card = prev[sourceCol]?.find((c) => c.id === cardId);
    if (!card) return false;

    // Optimistic update
    set((state) => ({
      columns: {
        ...state.columns,
        [sourceCol]: state.columns[sourceCol].filter((c) => c.id !== cardId),
        [targetCol]: [...state.columns[targetCol], { ...card, status: targetStatus as any }],
      },
    }));

    // API call
    const { error } = await handleApi(updateConfirmationStatus(cardId, targetStatus));
    if (error) {
      set({ columns: prev }); // Revert
      return false;
    }
    return true;
  },

  setSearchQuery: (query) => set({ searchQuery: query }),
  reset: () => set({ columns: {}, totals: {}, loading: true, searchQuery: "" }),
}));
